import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { eiwrsDepotManagementServices } from "../../../../APIServices/EIWRS/eiwrsDepotManagementServices";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const AddDepotForm = ({ getStudyDepotRowData, countryList }) => {
  let { studyId } = useParams();
  const [depotColumns, setDepotColumns] = useState([]);
  const [depotRow, setDepotRow] = useState("");
  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  const getStudyDepotColumnData = async (e) => {
    setLoader(true);
    let data = await eiwrsDepotManagementServices.getStudyDepotColumnData(
      "active",
      studyId
    );
    setDepotColumns(data?.data || []);
    setLoader(false);
  };

  const handleDepotRowChange = (e, columnKey) => {
    setDepotRow({
      ...depotRow,
      [columnKey]: e.target.value,
    });
  };

  const addNewStudyDepotRow = async () => {
    setButtonLoader(true);
    let userData = {};
    userData.studyId = studyId;
    userData.depotRow = depotRow;
    let data = await eiwrsDepotManagementServices.addNewStudyDepotRow(
      userData
    );
    if (data?.statusCode === 200) {
      clearForm();
      getStudyDepotColumnData();
      getStudyDepotRowData();
    }
    setButtonLoader(false);
  };

  useEffect(() => {
    clearForm();
    getStudyDepotColumnData();
  }, []);

  const clearForm = () => {
    setDepotRow("");
  };

  function isRowDataComplete() {
    return depotColumns.every((col) => {
      const key = col.columnName;
      return (
        depotRow.hasOwnProperty(key) &&
        depotRow[key] !== "" &&
        depotRow[key] !== null &&
        depotRow[key] !== undefined
      );
    });
  }

  return (
    <>
      {loader ? (
        <PageLoader />
      ) : depotColumns?.length === 0 ? (
        <div className="hstack justify-content-center h-100">
          <NoDataFoundTable MSG={"First create depot metadata"} />
        </div>
      ) : (
        <div className="p-2">
          {depotColumns?.map((item, index) => (
            <Form.Group key={index} className="mb-1">
              <Form.Label className="fw-bold mb-1">
                {item?.columnLabel}{" "}
                {item?.required === "yes" &&
                  <abbr title="Required" className="text-danger">
                    *
                  </abbr>
                }
              </Form.Label>
              {item?.columnType === "dropdown" ? (
                <>
                  {item?.customOption === "yes" ?
                    <>
                      {item?.columnName === "COUNTRY" &&
                        <Form.Select
                          value={depotRow?.[item?.columnName]}
                          onChange={(e) => handleDepotRowChange(e, item?.columnName)}
                          className="br3" style={{ fontSize: 12 }}>
                          <option value="">Select Country</option>
                          {countryList?.map((el, i) => (
                            <option index={i} value={el?.name}>{el?.name}</option>
                          ))}
                        </Form.Select>
                      }
                    </>
                    :
                    <Form.Select
                      onChange={(e) => handleDepotRowChange(e, item?.columnName)}
                      className="br3"
                      style={{ fontSize: 12 }}
                    >
                      <option value="">Select Option</option>
                      {(item?.columnOption || [])?.map((el, i) => (
                        <option
                          index={i}
                          selected={depotRow[item?.columnName] === el?.option}
                          value={el?.option}
                        >
                          {el?.option}
                        </option>
                      ))}
                    </Form.Select>
                  }
                </>
              ) : item?.columnType === "radio" ? (
                (item?.columnOption || [])?.map((el, i) => (
                  <Form.Check
                    key={i}
                    type="radio"
                    label={el?.option}
                    name={item?.columnName}
                    value={el?.option}
                    checked={depotRow[item?.columnName] === el?.option}
                    onChange={(e) =>
                      handleDepotRowChange(e, item?.columnName)
                    }
                    className="br3"
                  />
                ))
              ) : (
                item?.columnType === "textarea" ?
                  <Form.Control
                    onChange={(e) => handleDepotRowChange(e, item?.columnName)}
                    value={depotRow[item?.columnName] || ""}
                    className="br3"
                    placeholder={`Enter ${item?.columnLabel}`}
                    as={item?.columnType}
                  />
                  :
                  <Form.Control
                    onChange={(e) => handleDepotRowChange(e, item?.columnName)}
                    value={depotRow[item?.columnName] || ""}
                    className="br3"
                    placeholder={`Enter ${item?.columnLabel}`}
                    type={item?.columnType}
                  />
              )}
            </Form.Group>
          ))}
          <div className="text-end">
            <button
              disabled={!isRowDataComplete() || buttonLoader}
              title={
                !isRowDataComplete ? "Fill all required fields" : "Add Depot"
              }
              onClick={addNewStudyDepotRow}
              className={`updateProfile`}
            >
              {buttonLoader ? (
                <div className="hstack gap-2">
                  <Spinner size="sm" /> Adding...
                </div>
              ) : (
                "Add depot"
              )}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default AddDepotForm;
